import { useParams } from 'react-router-dom';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { ChatList } from '../../../features/chat/components/ChatList';
import { ChatSessionScreen } from '../../../features/chat/components/chatSession/ChatSessionScreen';
import useGetChatSessions from '../../../features/chat/hooks/useGetChatSessions';
import { ChatSession } from '../../../features/chat/types/ChatSession';
const Chat = () => {
  const { chatSessionId } = useParams();
  const { data: chatSessions, isLoading, isFetching } = useGetChatSessions();

  // if (!(isMetabolicUser || userId === "60532291-10fb-4652-aa11-a8cb247b6392")) {
  //   navigate("/home")
  // }
  if (isLoading) {
    return <LoadingSpinner/>;
  }
  if (!chatSessionId) {
    return <ChatList />;
  }
  const chatSession = chatSessions?.find(
    (session: ChatSession) => session.id === chatSessionId,
  );

  // TODO: handle case where chat session is not found
  if (!chatSession) {
    if (isFetching) {
      return <LoadingSpinner/>;
    } else {
      // TODO- TM: Improve UI
      return <div>Chat session not found</div>;
    }
  }

  return (
    <div className='w-full h-full'>
      <ChatSessionScreen chatSession={chatSession} />
    </div>
  );
};

export default Chat;
